import React from 'react'
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer'
import ForecastMonthStatContainer from '../../containers/forecastmonthstat/ForecastMonthStatContainer'

const ForecastMonthStatViewPage = () => {
    return (
        <div>
            <BreadcrumbsContainer title="포캐스팅 관리/포캐스팅 통계/중요도별 통계" icon="chance" />
            <ForecastMonthStatContainer />
        </div>
    )
}

export default ForecastMonthStatViewPage